query MfaSessionSummary($runId: ConditionID!) {
	mfa_session_runs(run_id_eq: $runId) {
		total_scans
		total_issues
		critical_issues
	}
	issues(run_id_eq: $runId, deleted_eq: { value: false }) {
		issue_id
		tickets__key
	}
	androidScans: scans(run_id_eq: $runId, os_eq: { value: ["ANDROID"] }) {
		os_count
	}
	iosScans: scans(run_id_eq: $runId, os_eq: { value: ["IOS"] }) {
		os_count
	}
}
